import {
  CheckCircleIcon,
  MinusIcon,
  XCircleIcon,
} from "@heroicons/react/24/solid";
import classNames from "classnames";
import { Difficulty } from "shared/games/Difficulty";
import { SwitchItem } from "ui/atoms/Switch/Switch";
import { Props } from "./DifficultySelector";

export default function getCompletionHistoryIcon({
  history,
  difficulty,
}: {
  history: Props["history"];
  difficulty: Difficulty;
}): SwitchItem<string>["icon"] | undefined {
  return function HistoryIcon({ className }) {
    if (!history) {
      return null;
    }

    if (!history[difficulty]) {
      return <MinusIcon className={classNames(className, "text-slate-300")} />;
    }

    return history[difficulty]?.correct ? (
      <CheckCircleIcon className={classNames(className, "text-emerald-500")} />
    ) : (
      <XCircleIcon className={classNames(className, "text-red-500")} />
    );
  };
}
